module.exports = __webpack_public_path__ + "static/img/8.d8779cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/8.gif
// module id = cmZJ
// module chunks = 0